import React, { Component } from "react";
// import Countries from "../../services/countries.service";
import Helpers from "../../helpers/shared.helper";
// import Forms from "../../services/forms.service";
import Storage from "../../services/storage.service";
import Numbers from "../../services/numbers.service";
import Translations from '../../services/translation.service';
import OperatorsSelectSkeleton from "../skeleton/operators-select.component";

export default class OperatorsSelect extends Component {
  state = {
    selected: null,
    selected_friendly: "",
    list_by_id: null,
    list: []
  };

  componentDidMount() {
    Storage.getOrfetch("phone_operators", Numbers.fetchMnpOperators)
      .then(res => {


        if (res.data) {
          Storage.set("phone_operators", res.data);

          this.setState({
            list: res.data,
            list_by_id: Helpers.arrayToObject(res.data, 'Id')
          });
        }
        else {
          Storage.set("phone_operators", res);

          this.setState({
            list: res,
            list_by_id: Helpers.arrayToObject(res, 'Id')
          });
        }

      })
      .catch(err => {
        // console.log(err);
      });

    this.setState({
      selected: this.props.default ? this.props.default : ""
    });
  }

  select(event) {
    if (event.target.value) {

      this.setState({
        selected: event.target.value,
        selected_friendly: this.state.list_by_id[event.target.value].Operator
      });
    }
    else {
      this.setState({
        selected: null,
        selected_friendly: "",
      });
    }

    this.props.updateFieled(event, 'form', 'select')
    // Forms.inputChangedHandler(this.props.form_id, event, this.props.field_name);
  }

  render() {
    let select_html = <OperatorsSelectSkeleton />;
    let list = this.state.list;
    let select_list = [];

    if (list.length) {
      for (var i = 0; i < list.length; i++) {

        select_list.push(
          <option key={i} value={list[i].Id}>
            {list[i].Operator}
          </option>
        );
      }
      select_list.unshift(
        <option key="1_1" value="">
          {Translations.keys["scr_17.0_MNP_form_tab_select_operator"]}
        </option>
      );
    }

    if (select_list.length) {
      select_html = (
        <div className="field-container">
            <label>{this.props.label}</label>
          <select className="storefront-search-input select-component" name="operator_id" onChange={e => this.select(e)}>{select_list}</select>
        </div>
      );
    }

    return select_html;
  }
}